export default class DisplayRounding {
    public static Round(value: number, digits?: number):number {
        if (!digits) {
            digits = 0;
        }
        if (isNaN(value) || isNaN(digits)) {
            return NaN;
        }
        const sValue:string = value.toString();
        const decimalPlace: number = sValue.indexOf('.');
        if (sValue.length <= digits) {
            return value;
        }
        if (decimalPlace < 0) {
            return value;
        } 
        
        if ( decimalPlace >= 0 && decimalPlace < digits ) {

            const tempString = sValue.substr(0, digits + 1);
            const roundingPlace = Number(tempString.substr(-1, 1));
            let roundedValue;
            if (roundingPlace >=5) {
                const roundedDigit = (Number(tempString[digits]) + 1).toString();
                if (roundedDigit === '10') {
                    roundedValue = Number(tempString.substr(0, digits - 1) + (Number(tempString[digits - 1]) + 1).toString());
                } else {
                    roundedValue = Number(tempString.substr(0, digits) + roundedDigit);
                }
            } else {
                roundedValue = Number(tempString.substr(0, digits));
            }
            return roundedValue;
        }
        return Math.round(value);

    }
    public static RoundMax(value: number, digits?: number) {
        if(Number(value) === 0 || !Number.isFinite(Number(value))) {
            return Number(0).toString();
        }
        const stringNumber = Number(value).toString();
        const fixedStringNumber = Number(value).toFixed(digits);
        if (stringNumber.length < fixedStringNumber.length) {
            return stringNumber;
        }
        return fixedStringNumber;

    }
    public static RoundStrict(value:number, digits?:number): string {
        if(Number(value) === 0 || !Number.isFinite(Number(value))) {
            return Number(0).toFixed(digits);
        }
        return Number(value).toFixed(digits);
    }
    public static RoundString(value: number, digits?: number):string {
        if (value === undefined || value === null || isNaN(value)) {
            return '';
        }
        return DisplayRounding.Round(value, digits).toString();
    }
}


// WEBPACK FOOTER //
// ./src/Services/DisplayRounding/DisplayRounding.ts